import type { Entity } from '@backstage/catalog-model';
import type { Path } from 'history';

import { isEqual } from 'es-toolkit';
import { isMatch } from 'es-toolkit/compat';
import { parse } from 'qs-esm';
import { resolvePath } from 'react-router';

import type { BreadcrumbPartType, NavItem } from '../../../types';

export const findActiveNavItem = (
  currentLocation: Path,
  breadcrumbs: readonly BreadcrumbPartType[],
  entity: Entity | undefined,
  navigation: readonly NavItem[] | undefined,
): NavItem | undefined => {
  if (!navigation?.length) {
    return undefined;
  }

  const currentDecodedSearch = new URLSearchParams(
    currentLocation.search,
  ).toString();

  const currentQueryParameters = parse(currentDecodedSearch);

  const isLocationMatch = (toLocation: Path) => {
    const toDecodedSearch = new URLSearchParams(toLocation.search).toString();
    const toQueryParameters = parse(toDecodedSearch);

    return (
      isEqual(
        // compare paths without trailing slashes
        toLocation.pathname.replace(/\/$/, ''),
        currentLocation.pathname.replace(/\/$/, ''),
      ) && isMatch(currentQueryParameters, toQueryParameters)
    );
  };

  const matchNavItem = (item: NavItem) => {
    if (isLocationMatch(resolvePath(item.target ?? ''))) {
      return true;
    }
    return !!(
      (item.entityMatcher && entity && item.entityMatcher(entity))
      ?? item.breadcrumbMatcher?.(breadcrumbs)
    );
  };

  for (const topNavItem of navigation ?? []) {
    if (matchNavItem(topNavItem)) {
      return topNavItem;
    }
  }
  return undefined;
};
